import styles from './Manutencao.module.scss';
import manutencaoIcon from '../../assets/manutencao-icon.png';
import { manutencao } from '../../environment/environment';

function Manutencao() {
  const { periodoEstimado } = manutencao;
  return (
    <div className={styles.container}>
      <img
        src={manutencaoIcon}
        alt='ícone de manutenção'
        className={styles.icon}
      />
      <div className={styles.textContainer}>
        <span className={styles.title}>Site em Manutenção</span>
        <br />
        <span
          className={styles.periodoMessage}
        >{`Período estimado: ${periodoEstimado}`}</span>

        <p className={styles.textContainer}>
          O sistema está temporariamente indisponível para manutenção. Pedimos
          desculpas pelo transtorno e agradecemos pela compreensão.
        </p>
      </div>
    </div>
  );
}

export default Manutencao;
